import config from '../config.js';

function create(mode){
	dy3d.album.add({mode});
}

function remove(id, success){
	dyEditor.dialog.show({
		title:"删除分组",
		confirmText:'确认删除',
		cancel:true,
		content:{
			title:'确定要删除这个分组吗？',
			text:'删除后分组内的全景会回到未分组状态'
		},
		success: res=>{
			if(res.confirm){
				dy3d.album.remove({id});
				success && success();
			}
		}
	})
}

function addPano({item, list, groups, data}){
	const panos = [];
	list.forEach(v=>{
		v.status==3 && (item.panoId.findIndex(p=>p==v.id)>=0 || groups.findIndex(g=>g.panoId.findIndex(n=>n==v.id)>=0)<0) && panos.push(v);
	});
	
	const selPanos = [...item.panoId];
	
	data.title			= '请选择要添加到['+item.name+']的场景';
	data.confirmText	= '确认选择';
	data.cancel			= true;
	data.cancelText		= '取消选择';
	data.width			= '1000px';
	data.height			= '753px';
	data.selected		= selPanos;
	data.panos			= panos;
	data.bottomText		= selPanos.length>0?'已选择'+ selPanos.length+'/'+panos.length+'个场景':'';
	data.select			= id=>{
		let idx = data.selected.indexOf(id);
		idx>=0 ? data.selected.splice(idx, 1) : data.selected.push(id);						
		data.bottomText = '已选择'+ data.selected.length+'/'+panos.length+'个场景';
		dyEditor.dialog.update('panos2', data);
	}
	
	data.selectAll		= ()=>{
		data.selected = data.selected.length == panos.length ? [] : panos.map(v=>v.id);
		data.bottomText = '已选择'+ data.selected.length+'/'+panos.length+'个场景';
		dyEditor.dialog.update('panos2', data);
	}
	
	data.success		= res=>{
		res.confirm && (item.panoId = [...data.selected]);
	}
	
	dyEditor.dialog.panos2(data);
}

export default {
	create,
	remove,
	addPano,
}